{
  "cms.catalogRow.action.copyUnitToLocale.sv": "Kopioi ruotsin luonnoksiin",
  "cms.catalogRow.action.copyUnitToLocale.en": "Kopioi englannin luonnoksiin",
  "cms.copyUnitToLocale.unavailable.noCategories": "Tällä kielellä ei ole vielä sisältökategorioita.",
  "cms.copyUnitToLocale.unavailable.categoryMissing": "Sisältökategoriaa \"{slug}\" ei ole vielä tällä kielellä.",
  "cms.copyUnitToLocale.done.sv": "Kopio luotu ruotsin luonnoksiin.",
  "cms.copyUnitToLocale.done.en": "Kopio luotu englannin luonnoksiin.",
  "cms.copyUnitToLocale.error.slugTaken": "Kopiota ei luotu: tämä sisältö on jo olemassa tällä kielellä.",
  "cms.copyUnitToLocale.error.incompleteUnit": "Tätä sisältöä ei voi kopioida: se ei ole kokonainen julkaisukokonaisuus.",
  "cms.copyUnitToLocale.error": "Kopiointi epäonnistui. Yritä uudelleen."
}
